import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible'
import service from './api/request.js'
import 'babel-polyfill';
import Es6Promise from 'es6-promise'
import Bridge from "./utils/bridge.js" //此路径根据实际bridge.js路径填写

Es6Promise.polyfill()
Vue.config.productionTip = false
Vue.prototype.$bridge = Bridge
Vue.use(Vant);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
